gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const leftText = document.querySelector(".banner_header .left");
  const rightText = document.querySelector(".banner_header .right");
  const desc = document.querySelector(".banner_header .desc");
  const imagesGrid = document.querySelector(".banner_images_grid");
  const images = document.querySelectorAll(".banner_images_grid img");
  const centerImage = images[4]; 
  const bannerSection = document.querySelector(".banner_images_section");

  if (!leftText || !rightText || !desc || !imagesGrid || !bannerSection || !centerImage) {
    return;
  } 

  // Check if we're on mobile
  const isMobile = window.innerWidth <= 768;

  gsap.set(bannerSection, { opacity: 0, pointerEvents: "none" });

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".banner",
      start: "top top",
      end: "+=2500",
      scrub: 2,
      pin: true,
      pinSpacing: true,
    },
  });

  tl.to(leftText, { x: "-40%", duration: 1 }, 0)
    .to(rightText, { x: "40%", duration: 1 }, 0)
    .to(centerImage, { scale: 1, duration: 1 }, 0.2)
    .to([leftText, rightText, desc], { opacity: 0, duration: 1 }, 0.2)
    .to(images, { opacity: (i) => (i !== 4 ? 1 : 1), duration: 1 }, ">")
    .to(imagesGrid, { scale: 1.5, duration: 1, ease: "power1.inOut" }, ">");

  // Only scale center image and fade out other images on desktop
  if (!isMobile) {
    tl.to(centerImage, { scale: 1.5, duration: 1, ease: "power1.inOut" })
      .to(
        images,
        { opacity: (i) => (i !== 4 ? 0 : 1), duration: 1, ease: "power1.inOut" },
        "<"
      );
  }

  tl.to(
      bannerSection,
      { opacity: 1, pointerEvents: "auto", duration: 1, ease: "power1.inOut" }
    );

  // Fade out center image only when slider appears (desktop only)
  if (!isMobile) {
    tl.to(centerImage, { opacity: 0, duration: 0.2, ease: "power2.in" }, ">");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const tooltip = document.getElementById("hotspot-tooltip");
  let isHovering = false;
  let lastHoveredSpot = null; 

  const bannerImagesSplide = document.querySelector(".banner_images_splide");
  if (!bannerImagesSplide) return;

  const splide = new Splide(bannerImagesSplide, {
    direction: "ttb",
    perPage: 1,
    height: "85vh",
    pagination: true,
    arrows: true,
    drag: true,
    wheel: false,
    focus: 0,
    gap: "20%",
    trimSpace: false,
    breakpoints: {
      768: {
        direction: "ltr",
        height: "auto",
        gap: "1rem",
      },
    },
  });

  // --- Custom numeric pagination ---
  splide.on("pagination:mounted", function (data) {
    data.list.classList.add("splide__pagination--custom");

    data.items.forEach(function (item, index) {
      let pageNumber = (index + 1).toString().padStart(2, "0");
      item.button.textContent = pageNumber;
      item.button.classList.add("custom-pagination-number");
    });

    function updateVisiblePagination() {
      const total = data.items.length;
      const activeIndex = splide.index;

      data.items.forEach((item, index) => {
        item.button.parentElement.style.display = "none";
        if (
          index === activeIndex ||
          index === (activeIndex - 1 + total) % total ||
          index === (activeIndex + 1) % total
        ) {
          item.button.parentElement.style.display = "block";
        }
      });
    }

    updateVisiblePagination();
    splide.on("moved", updateVisiblePagination);
  });

  // --- Tooltip handling ---
  function showTooltipForSpot(spot) {
    if (!spot) return;
    tooltip.innerText = spot.dataset.product;
    tooltip.style.display = "block";
    tooltip.style.position = "absolute";
    const rect = spot.getBoundingClientRect();
    tooltip.style.top = `${rect.top - 30}px`;
    tooltip.style.left = `${rect.left + 25}px`;
  }

  function showDefaultTooltip() {
    if (isHovering) return;

    // If user hovered something before, stick to that one
    if (lastHoveredSpot) {
      showTooltipForSpot(lastHoveredSpot);
      return;
    }

    // Otherwise, show first hotspot of active slide
    const activeSlide = splide.Components.Slides.getAt(splide.index).slide;
    const firstHotspot = activeSlide.querySelector(".hotspot");

    if (firstHotspot) {
      showTooltipForSpot(firstHotspot);
    } else {
      tooltip.style.display = "none";
    }
  }

  function bindHotspotEvents() {
    document.querySelectorAll(".hotspot").forEach((spot) => {
      spot.addEventListener("mouseenter", (e) => {
        isHovering = true;
        lastHoveredSpot = spot; 
        tooltip.innerText = spot.dataset.product;
        tooltip.style.display = "block";
        tooltip.style.position = "absolute";
        tooltip.style.top = `${e.clientY - 40}px`;
        tooltip.style.left = `${e.clientX + 15}px`;
      });

      spot.addEventListener("mousemove", (e) => {
        tooltip.style.top = `${e.clientY - 40}px`;
        tooltip.style.left = `${e.clientX + 15}px`;
      });

      spot.addEventListener("mouseleave", () => {
        isHovering = false;
        showDefaultTooltip(); 
      });

      spot.addEventListener("click", () => {
        window.open(
          `/shop?product=${encodeURIComponent(spot.dataset.product)}`,
          "_blank"
        );
      });
    });
  }

  splide.on("mounted moved", () => {
    lastHoveredSpot = null;
    showDefaultTooltip();
    bindHotspotEvents();
  });

  splide.mount();
});